import { CheckCircleOutlined } from '@ant-design/icons';
import * as S from '@unionfab/ufc-shop-commons';
import { i18nFormat } from '@unionfab/ufc-shop-commons';
import { Button, Spin } from 'antd';
import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { getUseShopQuoteStoreByCode } from '@/stores';

import styles from './index.module.less';
/**
 * 免费订单成功页面
 * @returns
 */
export const ShopQuoteFreeOrderSuccessPage = () => {
  const navigate = useNavigate();
  const orderCode = useParams().orderCode;
  const useShopQuoteStore = getUseShopQuoteStoreByCode(orderCode);

  const shopOrder = useShopQuoteStore(s => s.shopOrder);

  useEffect(() => {
    if (!shopOrder) {
      // 该页面只应该由 payment 转过来
      console.warn('illegal state, no order loaded (payment success)');
      navigate('/');
    }
  }, []);

  if (!shopOrder) {
    return <></>;
  }

  return (
    <section className={styles.container}>
      <div className={styles.result}>
        <div className={styles.successIcon}>
          <CheckCircleOutlined />
        </div>

        <div className={styles.thanks}>
          {i18nFormat('Thank you for your order')} !
        </div>

        <div className={styles.info}>
          <span>
            {i18nFormat('Your order code')}: {orderCode}
          </span>
          <span>
            {i18nFormat('Total Price')}:{' '}
            {S.toPriceStringWithOption(Number(0), {
              currency: shopOrder.requirements.quotation.currency,
            })}
          </span>
        </div>

        <div className={styles.goDetail}>
          <Link to={`/orders_history/${orderCode}?id=${shopOrder.id}`}>
            <Button type="primary">{i18nFormat('See the Order Detail')}</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
